(()=>{
  const tr = (key, params) => window.storeTranslate(key, params);
  const dialog=document.getElementById('ds-cookie-dialog');
  if(!dialog || dialog.dataset.bound)return;
  dialog.dataset.bound='true';
  const form=dialog.querySelector('form'),fields=form.querySelector('fieldset'),status=dialog.querySelector('[data-ds-cookie-status]');
  const names=['preferences','analytics','marketing','sale_of_data'];
  let api,lastTrigger;
  function load(){return new Promise((resolve,reject)=>{
    if(window.Shopify?.customerPrivacy)return resolve(window.Shopify.customerPrivacy);
    if(!window.Shopify?.loadFeatures)return reject(new Error('unavailable'));
    const timer=setTimeout(()=>reject(new Error('timeout')),10000);
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{clearTimeout(timer);if(error||!window.Shopify.customerPrivacy)reject(error||new Error('unavailable'));else resolve(window.Shopify.customerPrivacy);});
  });}
  document.querySelectorAll('[data-ds-cookie-open]').forEach(button=>button.addEventListener('click',async()=>{
    lastTrigger=button;dialog.showModal();fields.disabled=true;status.textContent=tr('s056');
    try{api=await load();const consent=api.currentVisitorConsent();names.forEach(n=>{form.elements[n].checked=consent[n]==='yes';});fields.disabled=false;status.textContent=tr('s057');}
    catch{status.textContent=tr('s058');}
  }));
  dialog.querySelector('[data-ds-cookie-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>lastTrigger?.focus());
  function save(choices){
    if(!api)return;fields.disabled=true;status.textContent=tr('s105');
    let finished=false;
    const timer=setTimeout(()=>{if(!finished){fields.disabled=false;status.textContent=tr('s059');}},10000);
    api.setTrackingConsent(choices,result=>{finished=true;clearTimeout(timer);fields.disabled=false;status.textContent=result?.error?tr('s060'):tr('s061');if(!result?.error)names.forEach(n=>{form.elements[n].checked=choices[n];});});
  }
  form.addEventListener('submit',event=>{event.preventDefault();save(Object.fromEntries(names.map(n=>[n,form.elements[n].checked])));});
  dialog.querySelector('[data-ds-cookie-reject]').addEventListener('click',()=>save(Object.fromEntries(names.map(n=>[n,false]))));
})();
